import React from "react";
import ReactApexChart from "react-apexcharts";
import "./styles/dashboard.css";

const UserPerformanceGraph = ({ data }) => {
  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
        columnWidth: "12px",
        dataLabels: {
          total: {
            enabled: false,
          },
        },
      },
    },
    xaxis: {
      type: data.xaxis.type,
      categories: data.xaxis.categories,
      labels: {
        style: {
          fontSize: "11px",
          colors: "#9CA3AF",
        },
      },
    },
    yaxis: {
      show: false,
    },
    legend: {
      show: false,
    },
    colors: ["#93C5FD", "#6EE7B7"],
    fill: {
      opacity: 1,
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <div style={{ width: "100%", padding: "0" }}>
      <ReactApexChart
        options={options}
        series={data.series}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default UserPerformanceGraph;
